export default "__VITE_ASSET__BsZLukEB__"